/* Cart drawer AJAX — Cart API nativa (paridad backend por construcción) */
(function(){
  var body = document.body;
  function money(c){ return "$" + (c/100).toLocaleString("es-MX",{minimumFractionDigits:2}) + " MXN"; }
  function open(){ body.classList.add("fdrawer-open"); refresh(); }
  function close(){ body.classList.remove("fdrawer-open"); }
  document.addEventListener("click", function(e){
    if(e.target.closest("[data-fdrawer-close]")) close();
    var cl = e.target.closest(".cart-link");
    if(cl){ e.preventDefault(); open(); }
  });
  function refresh(){
    fetch("/cart.js").then(r=>r.json()).then(function(cart){
      var box = document.getElementById("fdrawer-items");
      var badge = document.querySelector(".cart-count");
      if(badge) badge.textContent = cart.item_count;
      else if(cart.item_count){ var cl=document.querySelector(".cart-link");
        if(cl) cl.insertAdjacentHTML("beforeend",'<span class="cart-count">'+cart.item_count+'</span>'); }
      document.getElementById("fdrawer-total").textContent = money(cart.total_price);
      box.innerHTML = cart.items.length ? cart.items.map(function(it){
        return '<div class="fdrawer-line"><img src="'+(it.image||"")+'&width=120" alt="">' +
          '<div class="t"><a href="'+it.url+'">'+it.product_title+'</a><br><small>'+it.quantity+' &times; '+money(it.final_price)+'</small></div>' +
          '<div>'+money(it.final_line_price)+'</div></div>';
      }).join("") : '<p style="color:#82858c;font-weight:600;padding:20px 0">Está vacío.</p>';
    });
  }
  /* intercept PDP add-to-cart -> AJAX + drawer */
  document.addEventListener("submit", function(e){
    var f = e.target;
    if(f.action && f.action.indexOf("/cart/add") !== -1){
      e.preventDefault();
      fetch("/cart/add.js", {method:"POST", body:new FormData(f), headers:{"Accept":"application/json"}})
        .then(r=>r.json()).then(open);
    }
  });
  refresh();
})();
